// @ts-nocheck
import { useEffect, useState } from "react"
import { Link } from "react-router-dom"
import { useAuth } from "@/components/layout/AuthProvider"
import { supabaseClient } from "@/lib/supabase/client"
import { FeedContainer } from "@/components/feed/FeedContainer"
import { FeedHeader } from "@/components/feed/FeedHeader"
import { FeedSidebar } from "@/components/feed/FeedSidebar"
import { FeedSkeleton } from "@/components/feed/FeedSkeleton"
import { GuestBanner } from "@/components/auth/GuestBanner"

export default function FeedPage() {
  const { user, supabaseUser, initialized } = useAuth()
  const [subscribedTopics, setSubscribedTopics] = useState<string[]>([])
  const [topicsLoaded, setTopicsLoaded] = useState(false)

  useEffect(() => {
    if (!supabaseUser) { setTopicsLoaded(true); return }
    supabaseClient.from("topic_subscriptions").select("topic_id").eq("user_id", supabaseUser.id)
      .then(({ data }) => {
        setSubscribedTopics(data?.map(s => s.topic_id) || [])
        setTopicsLoaded(true)
      })
  }, [supabaseUser?.id])

  if (!initialized || !topicsLoaded) return <FeedSkeleton />

  return (
    <div className="container-app py-4">
      {!supabaseUser && <GuestBanner />}
      <div className="flex gap-6">
        <div className="flex-1 min-w-0 max-w-[620px]">
          <FeedHeader isAuthenticated={!!supabaseUser} hasSubscriptions={subscribedTopics.length > 0} />
          <FeedContainer userId={supabaseUser?.id || null} subscribedTopics={subscribedTopics} />
        </div>
        <div className="hidden xl:block w-[320px] flex-shrink-0">
          <FeedSidebar userId={supabaseUser?.id || null} />
        </div>
      </div>
    </div>
  )
}